import { Link, useNavigate } from "react-router-dom";
import { Trash2, Minus, Plus, ArrowRight, ShoppingCart } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { gbp } from "@/lib/api";

export default function Cart() {
  const { items, updateQty, removeItem, subtotal } = useCart();
  const nav = useNavigate();
  const shipping = 0;

  if (items.length === 0)
    return (
      <div className="max-w-3xl mx-auto px-4 py-24 text-center">
        <ShoppingCart className="w-14 h-14 mx-auto text-muted-foreground/40" />
        <h1 className="mt-5 text-2xl font-display font-bold">Your basket is empty</h1>
        <p className="mt-2 text-muted-foreground">Browse our collections to find the parts you need.</p>
        <Link to="/" className="mt-6 inline-flex items-center gap-2 bg-primary text-white px-6 py-3 rounded-sm font-semibold hover:bg-primary/90">Start shopping <ArrowRight className="w-4 h-4" /></Link>
      </div>
    );

  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-display font-black tracking-tighter mb-8">Your Basket</h1>
      <div className="grid lg:grid-cols-[1fr_360px] gap-8">
        <div className="space-y-3">
          {items.map((it) => (
            <div key={it.product_id} className="flex gap-4 bg-card border border-border rounded-sm p-4" data-testid={`cart-row-${it.slug}`}>
              <img src={it.image} alt={it.name} className="w-24 h-24 object-cover rounded-sm border border-border bg-white" />
              <div className="flex-1 min-w-0">
                <Link to={`/products/${it.slug}`} className="font-semibold hover:text-primary line-clamp-2">{it.name}</Link>
                <p className="text-sm text-muted-foreground mt-0.5">{gbp(it.price)} each</p>
                <div className="flex items-center gap-4 mt-3">
                  <div className="flex items-center border border-border rounded-sm">
                    <button onClick={() => updateQty(it.product_id, it.qty - 1)} className="p-2 hover:bg-muted"><Minus className="w-3.5 h-3.5" /></button>
                    <span className="w-9 text-center text-sm">{it.qty}</span>
                    <button onClick={() => updateQty(it.product_id, it.qty + 1)} className="p-2 hover:bg-muted"><Plus className="w-3.5 h-3.5" /></button>
                  </div>
                  <button onClick={() => removeItem(it.product_id)} className="text-destructive hover:bg-destructive/10 p-2 rounded-sm" data-testid={`remove-${it.slug}`}><Trash2 className="w-4 h-4" /></button>
                </div>
              </div>
              <div className="font-display font-bold text-lg">{gbp(it.price * it.qty)}</div>
            </div>
          ))}
        </div>

        <aside className="bg-card border border-border rounded-sm p-6 h-fit lg:sticky lg:top-28">
          <h2 className="font-display font-bold text-lg mb-4">Order Summary</h2>
          <div className="space-y-2.5 text-sm">
            <div className="flex justify-between"><span className="text-muted-foreground">Subtotal</span><span data-testid="summary-subtotal">{gbp(subtotal)}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Delivery</span><span className="font-semibold text-primary">FREE</span></div>
            <div className="border-t border-border pt-3 flex justify-between font-display font-bold text-lg">
              <span>Total</span><span data-testid="summary-total">{gbp(subtotal + shipping)}</span>
            </div>
          </div>
          <button onClick={() => nav("/checkout")} data-testid="proceed-checkout"
            className="mt-5 w-full bg-accent text-white py-3.5 rounded-sm font-bold hover:bg-accent/90 transition-colors flex items-center justify-center gap-2">
            Secure Checkout <ArrowRight className="w-4 h-4" />
          </button>
          <Link to="/" className="mt-3 block text-center text-sm text-muted-foreground hover:text-primary">Continue shopping</Link>
        </aside>
      </div>
    </div>
  );
}
